// color design tokens export
export const tokensDark = {
  grey: {
    0: "#ffffff", // manually adjusted
    10: "#f6f6f6", // manually adjusted
    50: "#f0f0f0", // manually adjusted
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
    1000: "#000000", // manually adjusted
  },
  primary: {
    // blue
    50: "#f0f0f0",
    100: "#d3d4de",
    200: "#a6a9be",
    300: "#7a7f9d",
    400: "#4d547d",
    500: "#21295c",
    600: "#191F45", // manually adjusted
    700: "#141937",
    800: "#0d1025",
    900: "#070812",
  },

  secondary: {
    50: "#f6f5fb", // manually adjusted — Claude Design brand purple ramp
    100: "#f3f0fc",
    200: "#ddd0fa",
    300: "#c4aef5",
    400: "#a87eef",
    500: "#7c3aed",
    600: "#6d28d9",
    700: "#5b21b6",
    800: "#4c1d95",
    900: "#341469",
  },

  // secondary: {
  //   50: "#f0f0f0", // manually adjusted
  //   100: "#fff6e0",
  //   200: "#ffedc2",
  //   300: "#ffe3a3",
  //   400: "#ffda85",
  //   500: "#ffd166",
  //   600: "#cca752",
  //   700: "#997d3d",
  //   800: "#665429",
  //   900: "#332a14",
  // },
  // secondary: {
  //   50: "#fff5f5", // very light pink
  //   100: "#fed7d7", // light pink
  //   200: "#feb2b2", // soft pink
  //   300: "#fc8181", // coral pink
  //   400: "#f56565", // bright coral
  //   500: "#e53e3e", // vibrant red
  //   600: "#c53030", // medium red
  //   700: "#9c2a2a", // deeper red
  //   800: "#742a2a", // dark red
  //   900: "#4a1a1a", // darkest red
  // },
};

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {};
  Object.entries(tokensDark).forEach(([key, val]) => {
    if (typeof val === "object" && val !== null) {
      const keys = Object.keys(val);
      const values = Object.values(val);
      const length = keys.length;
      const reversedObj = {};
      for (let i = 0; i < length; i++) {
        reversedObj[keys[i]] = values[length - i - 1];
      }
      reversedTokens[key] = reversedObj;
    } else {
      reversedTokens[key] = val;
    }
  });
  return reversedTokens;
}
export const tokensLight = reverseTokens(tokensDark);

// tokens function to get tokens based on mode
export const tokens = (mode) => {
  const selectedTokens = mode === "dark" ? tokensDark : tokensLight;
  return selectedTokens || tokensDark; // fallback to tokensDark if tokensLight is undefined
};

// mui theme settings
export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              ...tokensDark.primary,
              main: tokensDark.primary[400],
              light: tokensDark.primary[400],
            },
            secondary: {
              ...tokensDark.secondary,
              main: "#6d28d9",
              light: "#7c3aed",
              dark: "#5b21b6",
              contrastText: "#ffffff",
            },
            neutral: {
              ...tokensDark.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.primary[600],
              alt: tokensDark.primary[500],
            },
          }
        : {
            // palette values for light mode
            primary: {
              ...tokensLight.primary,
              main: tokensDark.grey[50],
              light: tokensDark.grey[100],
            },
            secondary: {
              ...tokensLight.secondary,
              main: "#6d28d9",
              light: "#7c3aed",
              dark: "#5b21b6",
              contrastText: "#ffffff",
            },
            neutral: {
              ...tokensLight.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.grey[0],
              alt: tokensDark.grey[50],
            },
          }),
    },
    typography: {
      fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Noto Sans Lao", "Inter", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};
